<template>
  <span class="btn btn-danger" @click="removeFeatureImage()">حذف عکس</span>
</template>

<script>

import {checkValueIsNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "FeatureRemoveImageButton",
  props: {
    productFeature: {}
  },
  methods: {
    checkValueIsNumber,
    removeFeatureImage() {
      if (confirm("آیا از حذف عکس اطمینان دارید؟")) {
        const form = {
          feature_product_id: this.productFeature.id
        }

        if (checkValueIsNumber(form.feature_product_id)) {
          let res = this.$store.dispatch('Product/deleteProductFeatureImage', form)
          res.then(res => {
            this.productFeature.image = null
            this.productFeature.preview = null
          })
        } else {
          this.productFeature.image = null
          this.productFeature.preview = null
        }


      }
    }
  }
}
</script>

<style scoped>

</style>